import { Heading, PageContainer } from "@flixbus/honeycomb-react";
import React from "react";

const CalculationAnalysis: React.FC = () => (
  <PageContainer>
    <Heading size={1}>Calculation Analysis</Heading>
  </PageContainer>
);

export default CalculationAnalysis;
